import { render, staticRenderFns } from "./VehiculeEdit.vue?vue&type=template&id=423449d1"
import script from "./VehiculeEdit.vue?vue&type=script&lang=ts"
export * from "./VehiculeEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports